import React from 'react';
import {copyToClipboard} from '../../utils/StringUtils';
import {ReactComponent as CopyIcon} from '../../resources/imgs/copy-white.svg';

export const CopyToBufferButton = ({value, style}) => {
  return <CopyIcon style={style} className={'copy-to-buffer-btn'} onClick={() => {
    copyToClipboard(value);
  }}/>;
};
